import themeModules, {
  CANONICAL_THEME_ID,
  DEPRECATED_THEME_IDS,
} from 'src/theme/themes';

import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export function useAppTheme() {
  const { user } = useAuthContext();

  const themeKey = user?.theme;
  const currentTheme =
    (themeKey && themeModules[themeKey]) || themeModules[CANONICAL_THEME_ID];

  return {
    allThemes: themeModules,
    canonicalThemeId: CANONICAL_THEME_ID,
    deprecatedThemeIds: DEPRECATED_THEME_IDS,
    currentTheme,
    /** Resolved API theme key, if any */
    activeThemeId: themeKey && themeModules[themeKey] ? themeKey : CANONICAL_THEME_ID,
  };
}
